/* -- Registro de Contratistas -- */
import RegistroProveedores from "../../../pages/adquisiciones/registro-proveedores/RegistroProveedores";

const rutasObra = [
    //Contratistas
    { path: "/template/contratistas", component: RegistroProveedores },
]

export default rutasObra;